import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { Popover } from './types';

const popoversSlice = (state: RootState) => state.popovers;

export const selectPopovers = createSelector([popoversSlice], (state): Popover => state);

export const selectPopover = <K extends keyof Popover>(key: K) =>
  createSelector([popoversSlice], (state): Popover[K] => state[key]);
